import { Box, Divider, Stack, Text } from "@mantine/core";
import type { Reference, ReferenceJson } from "src/db";
import { AnswerWithSources } from "./AnswerWithSources";
import type { FeedbackSchema } from "./MetadataFeedback/types";

interface ConversationThreadItem {
    _index: string;
    _id: string;
    _score: number;
    _source: {
        timestamp: string;
        conversation_id: string;
        id: string;
        user: string;
        org_code: string;
        source: string;
        question: string;
        cts_answer: {
            answer: string;
            comments: string | null;
            feedback_type: string | null;
            documents: ReferenceJson[];
        };
        request_options: {
            datasources: string[];
            product_line: string;
            memory_enabled: boolean;
        };
        evaluations: {
            sme: {
                comments: string;
                id: string;
                feedback_type: string;
                status: string;
            };
        };
    };
    sort: number[];
}

interface ConversationThreadListProps {
    conversationThread: ConversationThreadItem[];
    rowData: FeedbackSchema | null;
}

const ConversationThreadList = ({ conversationThread }: ConversationThreadListProps) => {
    return (
        <div style={{ height: "60vh", overflow: "auto", padding: "16px" }}>
            <Stack gap="xl">
                {conversationThread.map((message) => {
                    const messageAnswer = message._source.cts_answer.answer;

                    let messageReferences: Reference[] | undefined;
                    const messageDocuments = message._source.cts_answer.documents;

                    if (messageDocuments && messageDocuments.length > 0) {
                        messageReferences = messageDocuments.map((reference) => ({
                            reference_id: reference.reference_id,
                            title: reference.title,
                            source: decodeURIComponent(reference.source || ""),
                            dataSourceType: reference.data_source_type,
                        }));
                    }

                    return (
                        <Box key={message._source.id} mb="xl">
                            <Text size="lg" fw={700} mb="md">
                                Question: {message._source.question}
                            </Text>
                            <Divider my="md" />
                            <AnswerWithSources
                                answer={messageAnswer}
                                references={messageReferences}
                            />
                        </Box>
                    );
                })}
            </Stack>
        </div>
    );
};

export default ConversationThreadList;
